import React from 'react';
import { Link } from 'react-router-dom';
import { AgentDefinition } from '../types';

interface ChatHeaderProps {
  agent: AgentDefinition | null;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ agent }) => {
  const statusBadge = () => {
    if (!agent) return null;
    if (agent.mode === 'external-link') {
      return (
        <a
          href={agent.externalUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="chat-header__status chat-header__status--external"
          title="Open in new tab"
        >
          Open in new tab ↗
        </a>
      );
    }
    if (agent.mode === 'planned') {
      return <div className="chat-header__status chat-header__status--planned">Coming soon</div>;
    }
    if (!agent.endpoints?.chatUrl) {
      return <div className="chat-header__status chat-header__status--error">⚠ Misconfigured</div>;
    }
    return (
      <div className="chat-header__status">
        <span className="chat-header__status-dot" />
        {agent.endpoints.chatStreamUrl ? 'Streaming' : 'Online'}
      </div>
    );
  };

  return (
    <div className="chat-header">
      {agent ? (
        <div className="chat-header__agent">
          <div
            className="chat-header__avatar"
            style={{ background: agent.color }}
          >
            <span>{agent.icon}</span>
          </div>
          <div className="chat-header__agent-info">
            <div className="chat-header__agent-name">{agent.name}</div>
            <div className="chat-header__agent-desc">{agent.description}</div>
          </div>
        </div>
      ) : (
        <div className="chat-header__agent">
          <div className="chat-header__agent-name chat-header__agent-name--empty">
            Select an agent to start chatting
          </div>
        </div>
      )}
      <div className="chat-header__actions">
        {statusBadge()}
        <Link to="/ai-chat-agents" className="chat-header__back" title="Back to Catalog">
          ←
        </Link>
      </div>
    </div>
  );
};
